module.exports = __webpack_public_path__ + "media/v2/components/shared/Image/background_1-155518a834755eb5da0edfd696e01c65.png";